import { BoxProps, TextProps } from '@jfs/ui-new'

export const styles = {
  resendContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,

  resendTouchable: {
    alignSelf: 'center',
    width: 180,
    marginTop: 8,
    zIndex: 9999,
  } as BoxProps,

  countStyle: {
    fontSize: 12,
    fontWeight: '600',
    width: 16,
    marginStart: 4,
    color: 'CLOUDY_GREY',
  } as TextProps,

  secondStyle: {
    fontSize: 12,
    fontWeight: '600',
    color: 'CLOUDY_GREY',
  } as TextProps,
}
